module.exports = __webpack_public_path__ + "static/media/tickets.ce52429f.svg";